import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

export function RenderOrderDetail() {
  const { t } = useTranslation('common');

  const {
    purchaseOrderData: { devorderData, previewDevData },
  } = useSelector((reduxState) => reduxState);
  return (
    <Card className="listing-card">
      <Card.Header className="py-2 px-2 bgcolor-dark">
        <strong>{t('FILTER.ORDER_DETAILS')}</strong>
      </Card.Header>
      <Card.Body>
        <Row className="span_font_size">
          <Col lg={6}>
            <ul className="order-detail-list">
              <li>
                <b>{t('FILTER.PRODUCT_NUMBER')}</b> {devorderData?.number || previewDevData?.number}
              </li>
              <li>
                <b>{t('FILTER.PRODUCT_DESCRPTION')}</b> {devorderData?.description || previewDevData?.description}
              </li>
              <li>
                <b>{t('FILTER.SEASON')}</b> {devorderData?.season || previewDevData?.season}
              </li>
              <li>
                <b>{t('TAKING_DATES.BRAND')}</b> {devorderData?.brand || previewDevData?.brand}
              </li>
            </ul>
          </Col>
          <Col lg={6}>
            <ul className="order-detail-list">
              <li>
                <b>{t('FILTER.CATEGORY_1')}</b> {devorderData?.catOne || previewDevData?.catOne}
              </li>
              <li>
                <b>{t('FILTER.CATEGORY_2')}</b> {devorderData?.catTwo || previewDevData?.catTwo}
              </li>
              <li>
                <b>{t('FILTER.CATEGORY_3')}</b> {devorderData?.catThree || previewDevData?.catThree}
              </li>
              <li>
                <b>{t('FILTER.CATEGORY_4_')}</b> {devorderData?.catFour || previewDevData?.catFour}
              </li>
            </ul>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default RenderOrderDetail;
